<template>
	<div>
		<div class="dropdown" v-if="enlaces.length>0">
			<button class="btn btn-light dropdown-toggle w-100" type="button" id="dropdownMenuEnlacesCrm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				{{nameDF}}
			</button>
			<div class="dropdown-menu" aria-labelledby="dropdownMenuEnlacesCrm" style="min-width: 100%;">
				<h6 class="dropdown-header text-center">Otras aplicaciones</h6>
				<div class="form-row justify-content-center align-items-stretch m-0">
					<div v-for="(enlace, index) in enlaces" :key="index" :class="{'text-center p-2 border-top':true, 'border-left':(index+1)%2==0, 'col-12':((index+1)%2!=0) && enlaces.length==(index+1), 'col-6':!(((index+1)%2!=0) && enlaces.length==(index+1))}">
						<a :href="toEnlace(enlace.ENLACE)" :class="{'text-truncate':true, 'w-50 d-block mx-auto':((index+1)%2!=0) && enlaces.length==(index+1)}" :title="enlace.DESCRIPCION">
							<img :src="enlace.IMAGEN" class="img-fluid" v-if="enlace.IMAGEN">
							<p class="text-truncate mb-0">
				    			{{enlace.DESCRIPCION}}
							</p>
					    </a>
					</div>
				</div>
			</div>
		</div>
		
		<p v-else class="mb-0 text-center">
			{{nameDF}}
		</p>
	</div>
</template>
<script>
	export default {
		props: ['name'],

		mounted(){
			this.getEnlaces();
		},

		data(){
			return {
				enlaces: [],
				loading: false,
			}
		},

		computed: {
			nameDF(){
				return this.name
			}
		},

		methods: {
			toEnlace(value){
				var url = new URL(value)
				var dd = crm.email || ''
				if(dd){
					url.searchParams.set('email', dd)
				}
				return url.href
			},
			getEnlaces: function(){
				this.loading = true;
				var url = 'api/catalogos/crmEnlace';

				axios.post(url)
				.then(response => {
					this.enlaces = response.data;
				}).catch(error => {
					return error
				}).then(()=>{
					this.loading = false;
				});
			},
		},
	}
</script>